import styled from 'styled-components';

export const Image = styled.img`
  width: 36px;
  height: 36px;
`;
